import React from 'react'
import { Svg } from '../../../..'

export const NewHomeLightSvg = () => (
  <Svg
    width='192'
    height='85'
    viewBox='0 0 192 85'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M191.22 49.937C191.22 16.437 113.239 5.93701 60.2194 5.93701C7.2001 5.93701 -13.7174 18.437 9.21948 49.937C46.7195 101.437 65.2002 75.437 118.219 75.437C171.239 75.437 191.22 68.937 191.22 49.937Z'
      fill='#E3E9F0'
    />
    <path
      d='M110.241 65.4949H80.9802V50.4731H110.241L115.759 57.984L110.241 65.4949Z'
      fill='var(--brand-primary-custom, var(--brand-primary-300))'
    />
    <path
      d='M133.192 32.6605L88.9495 7.084L88.989 1.88965L135.461 28.7153L133.192 32.6605Z'
      fill='#E3E9F0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M88.7106 0.126009C88.981 -0.14474 89.5743 0.0736183 89.9411 0.287107L136.564 27.4211C136.839 27.5811 137.038 28.9442 137.116 29.2524C137.195 28.4611 137.147 28.788 136.982 29.0601L135.322 32.903C135.107 33.258 134.722 33.4749 134.307 33.4749H131.247C130.592 33.4749 130.061 32.9439 130.061 32.289C130.061 31.634 130.592 31.103 131.247 31.103H133.639L134.328 28.8642L90.5305 3.37443V10.1517C90.5305 10.8066 89.9996 11.3376 89.3446 11.3376C88.6896 11.3376 88.1587 10.8066 88.1587 10.1517V1.31208C88.1587 0.887656 88.1608 0.675763 88.7106 0.126009Z'
      fill='#383B40'
    />
    <path
      d='M100.018 65.8901H95.2742V83.2837H100.018V65.8901Z'
      fill='#E3E9F0'
    />
    <path
      d='M100.018 46.1245H95.2742V50.0776H100.018V46.1245Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M78.6711 50.473C78.6711 49.8181 79.2021 49.2871 79.8571 49.2871H111.007C111.372 49.2871 111.717 49.455 111.942 49.7424L117.816 57.2533C118.152 57.6825 118.152 58.2853 117.816 58.7145L111.942 66.2254C111.717 66.5127 111.372 66.6807 111.007 66.6807H79.8571C79.2021 66.6807 78.6711 66.1497 78.6711 65.4948V50.473ZM81.043 51.659V64.3088H110.429L115.376 57.9839L110.429 51.659H81.043Z'
      fill='#E5DFF5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M94.879 64.3091C95.534 64.3091 96.065 64.84 96.065 65.495V82.8886C96.065 83.5435 95.534 84.0745 94.879 84.0745C94.2241 84.0745 93.6931 83.5435 93.6931 82.8886V65.495C93.6931 64.84 94.2241 64.3091 94.879 64.3091Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M100.413 64.3091C101.068 64.3091 101.599 64.84 101.599 65.495V82.8886C101.599 83.5435 101.068 84.0745 100.413 84.0745C99.7585 84.0745 99.2275 83.5435 99.2275 82.8886V65.495C99.2275 64.84 99.7585 64.3091 100.413 64.3091Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M78.6711 50.473C78.6711 49.8181 79.2021 49.2871 79.8571 49.2871H111.007C111.372 49.2871 111.717 49.455 111.942 49.7424L117.816 57.2533C118.152 57.6825 118.152 58.2853 117.816 58.7145L111.942 66.2254C111.717 66.5127 111.372 66.6807 111.007 66.6807H79.8571C79.2021 66.6807 78.6711 66.1497 78.6711 65.4948V50.473ZM81.043 51.659V64.3088H110.429L115.376 57.9839L110.429 51.659H81.043Z'
      fill='#383B40'
      stroke='#E3E9F0'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M60.0919 73.0059C60.7469 73.0059 61.2779 73.5368 61.2779 74.1918V82.8886C61.2779 83.5435 60.7469 84.0745 60.0919 84.0745C59.437 84.0745 58.906 83.5435 58.906 82.8886V74.1918C58.906 73.5368 59.437 73.0059 60.0919 73.0059Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M67.2074 73.0059C67.8624 73.0059 68.3933 73.5368 68.3933 74.1918V82.8886C68.3933 83.5435 67.8624 84.0745 67.2074 84.0745C66.5524 84.0745 66.0215 83.5435 66.0215 82.8886V74.1918C66.0215 73.5368 66.5524 73.0059 67.2074 73.0059Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M74.3226 73.0059C74.9776 73.0059 75.5086 73.5368 75.5086 74.1918V82.8886C75.5086 83.5435 74.9776 84.0745 74.3226 84.0745C73.6677 84.0745 73.1367 83.5435 73.1367 82.8886V74.1918C73.1367 73.5368 73.6677 73.0059 74.3226 73.0059Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M81.4386 73.0059C82.0936 73.0059 82.6245 73.5368 82.6245 74.1918V82.8886C82.6245 83.5435 82.0936 84.0745 81.4386 84.0745C80.7836 84.0745 80.2527 83.5435 80.2527 82.8886V74.1918C80.2527 73.5368 80.7836 73.0059 81.4386 73.0059Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M88.5538 73.0059C89.2088 73.0059 89.7398 73.5368 89.7398 74.1918V82.8886C89.7398 83.5435 89.2088 84.0745 88.5538 84.0745C87.8989 84.0745 87.3679 83.5435 87.3679 82.8886V74.1918C87.3679 73.5368 87.8989 73.0059 88.5538 73.0059Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M51 77.3539C51 76.6989 51.531 76.168 52.1859 76.168H93.298C93.953 76.168 94.4839 76.6989 94.4839 77.3539C94.4839 78.0089 93.953 78.5398 93.298 78.5398H52.1859C51.531 78.5398 51 78.0089 51 77.3539Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M51 83.7719C51 83.1169 51.531 82.5859 52.1859 82.5859H139.475C140.13 82.5859 140.661 83.1169 140.661 83.7719C140.661 84.4268 140.13 84.9578 139.475 84.9578H52.1859C51.531 84.9578 51 84.4268 51 83.7719Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M88.7555 5.92084C89.1246 5.70958 89.5785 5.71212 89.9452 5.9275L131.848 30.5394C132.211 30.7524 132.433 31.1415 132.433 31.562V39.4049C132.433 40.0599 131.902 40.5908 131.247 40.5908C130.592 40.5908 130.061 40.0599 130.061 39.4049V32.2408L90.5305 9.02201V46.5205C90.5305 47.1754 89.9996 47.7064 89.3446 47.7064C88.6896 47.7064 88.1587 47.1754 88.1587 46.5205V6.95009C88.1587 6.52481 88.3864 6.13209 88.7555 5.92084Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M90.3471 25.6312C90.697 26.1849 90.5317 26.9174 89.978 27.2673L56.534 48.3992V50.0781H60.0917C60.7467 50.0781 61.2777 50.609 61.2777 51.264V69.4482C61.2777 70.1032 60.7467 70.6341 60.0917 70.6341C59.4368 70.6341 58.9058 70.1032 58.9058 69.4482V52.4499H55.348C54.6931 52.4499 54.1621 51.919 54.1621 51.264V47.7458C54.1621 47.3389 54.3706 46.9605 54.7146 46.7432L88.7111 25.2621C89.2648 24.9123 89.9973 25.0775 90.3471 25.6312Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M89.9788 31.8099C90.3397 32.3565 90.1892 33.0921 89.6426 33.453L60.6191 52.6176C60.0725 52.9785 59.3369 52.828 58.976 52.2814C58.6151 51.7349 58.7656 50.9992 59.3121 50.6383L88.3357 31.4738C88.8822 31.1129 89.6179 31.2634 89.9788 31.8099Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M61.2778 25.1737C61.2778 24.5187 61.8088 23.9878 62.4638 23.9878H74.323C74.978 23.9878 75.5089 24.5187 75.5089 25.1737V29.9174C75.5089 30.5724 74.978 31.1033 74.323 31.1033H73.1371V36.2424C73.1371 36.8973 72.6061 37.4283 71.9512 37.4283C71.2962 37.4283 70.7652 36.8973 70.7652 36.2424V29.9174C70.7652 29.2625 71.2962 28.7315 71.9512 28.7315H73.1371V26.3596H63.6497V28.7315H64.8356C65.4906 28.7315 66.0215 29.2625 66.0215 29.9174V40.9861C66.0215 41.641 65.4906 42.172 64.8356 42.172C64.1806 42.172 63.6497 41.641 63.6497 40.9861V31.1033H62.4638C61.8088 31.1033 61.2778 30.5724 61.2778 29.9174V25.1737Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M88.1587 40.1952C88.1587 39.5402 88.6896 39.0093 89.3446 39.0093H135.991C136.646 39.0093 137.177 39.5402 137.177 40.1952V48.1014C137.177 48.7563 136.646 49.2873 135.991 49.2873H132.433V59.17C132.433 59.825 131.902 60.3559 131.247 60.3559C130.592 60.3559 130.061 59.825 130.061 59.17V48.1014C130.061 47.4464 130.592 46.9154 131.247 46.9154H134.805V41.3811H89.3446C88.6896 41.3811 88.1587 40.8502 88.1587 40.1952Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M111.858 77.3546C111.858 76.6887 112.398 76.1489 113.064 76.1489H136.782C137.448 76.1489 137.988 76.6887 137.988 77.3546V82.8889C137.988 83.5548 137.448 84.0946 136.782 84.0946C136.116 84.0946 135.576 83.5548 135.576 82.8889V78.5603H114.269V82.8889C114.269 83.5548 113.729 84.0946 113.064 84.0946C112.398 84.0946 111.858 83.5548 111.858 82.8889V77.3546Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M119.783 59.9608C119.783 59.3059 120.314 58.7749 120.969 58.7749H135.2C135.855 58.7749 136.386 59.3059 136.386 59.9608V63.9139C136.386 64.5689 135.855 65.0998 135.2 65.0998H122.155V74.9825C122.155 75.6375 121.624 76.1685 120.969 76.1685C120.314 76.1685 119.783 75.6375 119.783 74.9825V59.9608ZM122.155 62.728H134.014V61.1468H122.155V62.728Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M131.248 62.7275C131.903 62.7275 132.434 63.2585 132.434 63.9135V76.5633C132.434 77.2183 131.903 77.7493 131.248 77.7493C130.593 77.7493 130.062 77.2183 130.062 76.5633V63.9135C130.062 63.2585 130.593 62.7275 131.248 62.7275Z'
      fill='#383B40'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M114.249 48.1015C114.249 47.4465 114.78 46.9155 115.435 46.9155H131.247C131.902 46.9155 132.433 47.4465 132.433 48.1015C132.433 48.7564 131.902 49.2874 131.247 49.2874H115.435C114.78 49.2874 114.249 48.7564 114.249 48.1015Z'
      fill='#383B40'
    />
    <path
      d='M88.4496 55.8284C88.2649 55.5906 88.0262 55.4004 87.7532 55.2734C87.4802 55.1465 87.1809 55.0866 86.8801 55.0986C85.954 55.0986 85.5146 55.4831 85.5146 55.9697C85.5146 56.4562 86.1895 56.7074 86.9821 56.8015C88.3554 56.9742 89.6346 57.3273 89.6346 58.8968C89.6346 60.4664 88.3397 61 86.8722 61C85.5224 61 84.5179 60.5841 84 59.3834L85.0202 58.8419C85.1861 59.1836 85.4523 59.4665 85.7832 59.653C86.1141 59.8395 86.494 59.9206 86.8722 59.8856C87.657 59.8856 88.3868 59.6188 88.3868 58.8968C88.3868 58.1749 87.7354 58.0258 86.8644 57.9316C85.5146 57.7746 84.2747 57.4136 84.2747 55.9383C84.2747 54.463 85.6088 54.0235 86.8251 54.0156C87.3373 53.9599 87.8547 54.054 88.3145 54.2866C88.7742 54.5193 89.1564 54.8804 89.4148 55.3262L88.4496 55.8284Z'
      fill='white'
    />
    <path d='M99.2492 54V59.7819H102.665V61H98V54H99.2492Z' fill='white' />
    <path
      d='M96.6524 57.6778C96.6524 58.3454 96.537 58.9318 96.3061 59.4372C96.0753 59.9394 95.7447 60.3262 95.3142 60.5976C94.8868 60.8659 94.3939 61 93.8356 61C93.2834 61 92.7906 60.8659 92.357 60.5976C91.9265 60.3262 91.5927 59.941 91.3556 59.4418C91.1217 58.9427 91.0031 58.3672 91 57.7152V57.3316C91 56.6671 91.117 56.0807 91.3509 55.5722C91.588 55.0637 91.9202 54.6754 92.3476 54.4071C92.7781 54.1357 93.2709 54 93.8262 54C94.3815 54 94.8728 54.1341 95.3001 54.4024C95.7306 54.6676 96.0628 55.0512 96.2968 55.5535C96.5307 56.0526 96.6493 56.6344 96.6524 57.2988V57.6778ZM95.4686 57.3222C95.4686 56.5673 95.3251 55.9886 95.0381 55.5862C94.7542 55.1838 94.3503 54.9826 93.8262 54.9826C93.3146 54.9826 92.9138 55.1838 92.6237 55.5862C92.3367 55.9855 92.1901 56.5517 92.1838 57.2848V57.6778C92.1838 58.4265 92.3289 59.0051 92.619 59.4138C92.9122 59.8224 93.3177 60.0267 93.8356 60.0267C94.3596 60.0267 94.762 59.8271 95.0428 59.4278C95.3266 59.0285 95.4686 58.4452 95.4686 57.6778V57.3222Z'
      fill='white'
    />
    <path
      d='M104 61V54H106.067C106.686 54 107.234 54.1378 107.712 54.4135C108.192 54.6891 108.564 55.0801 108.827 55.5865C109.09 56.0929 109.221 56.6731 109.221 57.3269V57.6779C109.221 58.3413 109.088 58.9247 108.822 59.4279C108.559 59.9311 108.183 60.3189 107.692 60.5913C107.205 60.8638 106.646 61 106.014 61H104ZM105.216 54.9808V60.0288H106.01C106.647 60.0288 107.136 59.8301 107.476 59.4327C107.819 59.0321 107.994 58.4583 108 57.7115V57.3221C108 56.5625 107.835 55.9824 107.505 55.5817C107.175 55.1811 106.696 54.9808 106.067 54.9808H105.216Z'
      fill='white'
    />
  </Svg>
)

export default NewHomeLightSvg
